import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TagInputComponent } from '../tag-input/tag-input.component';
import { MatDivider } from '@angular/material/divider';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { WorkspaceDocVersion } from '@workspaces/models/versions';
import { WorkspaceVersionService } from '@workspaces/services/version.service';
import { finalize, Subscription } from 'rxjs';
import { AppState } from 'src/app/state/app.state';
import { Store } from '@ngrx/store';
import { WorkspaceVersionFetch } from '@workspaces/store/workspace-version.feature';
import { MatButtonModule } from '@angular/material/button';
import { LoaderButtonComponent } from '../loader-button/loader-button.component';

@Component({
  selector: 'app-version-meta-dialog',
  templateUrl: './version-meta-dialog.component.html',
  styleUrls: ['./version-meta-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    TagInputComponent,
    MatDivider,
    ReactiveFormsModule,
    MatInput,
    LoaderButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionMetaDialogComponent implements OnDestroy {
  public alias = new FormControl<string>('', { nonNullable: true });
  public tags = new FormControl<string[]>([], { nonNullable: true });
  public isSaving = false;
  private readonly sub = new Subscription();
  constructor(
    public readonly dialogRef: MatDialogRef<VersionMetaDialogComponent>,
    private readonly versionService: WorkspaceVersionService,
    private readonly store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: {
      workspaceId: string;
      version: WorkspaceDocVersion;
    }
  ) {
    this.alias.setValue(this.data.version.alias ?? '');
    this.tags.setValue(this.data.version.tags ?? []);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  save() {
    this.isSaving = true;
    this.sub.add(
      this.versionService
        .updateVersion(this.data.workspaceId, this.data.version.version_id, {
          alias: this.alias.value,
          tags: this.tags.value
        })
        .pipe(
          finalize(() => {
            this.isSaving = false;
          })
        )
        .subscribe(() => {
          this.store.dispatch(WorkspaceVersionFetch({ workspaceId: this.data.workspaceId }));
          this.dialogRef.close();
        })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
